<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :pagination="pagination"
    :headers="headers"
    :actions="actions"
    :list="list"
    :full-width-actions="false"
    dense
    v-on="$listeners || {}"
  >
    <template #item="{ item }">
      <tr>
        <th colspan="6">
          <v-subheader>{{ item.indicatorName }}</v-subheader>
        </th>
      </tr>
      <tr
        v-for="(log, logIdx) in item.logs"
        :key="[log.indicator_id, logIdx].join('.')"
      >
        <td
          v-for="v in headers"
          :key="[v.value, log.indicator_id, logIdx].join('.')"
          :style="v.style || ''"
        >
          <span v-if="v.getValue" v-html="v.getValue(log)" />
          <span v-else>{{ log[v.value] }}</span>
        </td>

        <td>
          <BTableButtonAction
            v-for="(action, aIndex) in actions"
            :key="action.action"
            :action="action"
            :index="aIndex"
            :data="log"
            :list="list"
            v-on="$listeners"
          />
        </td>
      </tr>
    </template>
  </BTable>
</template>

<script>
import BTable from '@/components/common/BTable.vue'
import BTableButtonAction from '@/components/common/BTable/BTableButtonAction.vue'
import {
  LOGS_TABLE_ACTIONS, LOGS_TABLE_HEADERS,
} from '@/views/LKMunMeh/Form/table-headers'

export default {
  name: 'BTableMunMehCuratorForms',
  components: { BTable, BTableButtonAction },
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => LOGS_TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => LOGS_TABLE_ACTIONS,
    },
    pagination: {
      type: Object,
      required: true,
    },
    list: {
      type: Array,
    },
  },
}
</script>
